import React from 'react'
import style from "./Header.module.css"

const Header = () => {
  return (
    <div className={style.header}>
        <h1 className={style.title}>SAHAFİSTAN</h1>
    </div>
  )
}

export default Header